import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PlanCheckoutIndex } from '@/pages/billing/PlanCheckoutIndex';

const checkoutSearchSchema = z.object({
	addons: z.string().optional(),
	addOn: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/settings/billing/pricing/checkout')({
	component: PlanCheckoutIndex,
	validateSearch: checkoutSearchSchema,
});
